import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetOPDDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OPD/GetDetail?` + params, null);

export const GetOPDList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OPD/GetList?` + params, null);

export const CreateOPD = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPD/Create`, data);

export const UpdateOPD = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPD/Update`, data);

export const DeleteOPD = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPD/Delete`, data);

export const CheckOutOPD = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPD/CheckOutOPD`, data);

export const CancelOPD = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPD/CancelOPD`, data);

export const GetOPDCaseNumberList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OPD/GetOPDCaseNumberList?` + params, null);

export const UpdateOPDClinicMode = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPD/UpdateOPDClinicMode`, data);

export const UpdateOPDByTemplate = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPD/UpdateByTemplate`, data);

export const ResetOPD = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPD/ResetOPD`, data);

export const GetOpdMessagePreview = (data: any) =>
  POST_ENC(`${BASE_URL}/api/OPD/GetOpdMessagePreview`, data);

export const GetPreviousOPDDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OPD/GetPreviousOPDDetail?` + params, null);

export const GetProcedurePendingStatusList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OPD/GetProcedurePendingStatusList?` + params, null);


